import {
  getApiV1ThreeLetterCodePartnerAdminsClientsClientId,
  getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** クライアントID */
  clientId: string;
};

type ReturnType = {
  /** クライアントデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
};

/**
 * useGetClientフックの型定義
 */
type IUseGetClient = (args: Args) => ReturnType;

/**
 * 利用企業編集フォーム用クライアント詳細取得フック
 */
export const useGetClient: IUseGetClient = ({ threeLetterCode, clientId }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey(threeLetterCode, clientId),
    () => getApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode, clientId),
    { suspense: true }
  );

  return {
    data,
  };
};
